import { useState } from "react";
import { copyTextToClipboard } from "shared/utility/CommonUtility";

interface Props {
  text: string;
  copyTextCaption?: string;
  copiedTextCaption?: string;
  onCopy?: () => void;
}

export default function PromineoCopyClipboard(props: Props) {
  const [shouldDisplayCopied, setShouldDisplayCopied] = useState(false);

  const handleCopyClick = () => {
    copyTextToClipboard(props.text);
    props.onCopy?.();
    if (!shouldDisplayCopied) {
      setShouldDisplayCopied(true);
      setTimeout(() => {
        setShouldDisplayCopied(false);
      }, 4000);
    }
  };

  return (
    <div
      className="bg-primaryRed text-white text-center py-1 w-46 rounded font-semibold cursor-pointer"
      onClick={handleCopyClick}
    >
      {shouldDisplayCopied ? (
        <>
          {props.copiedTextCaption ?? "copied"}
          <i className="icon dx-icon-check ml-1"></i>
        </>
      ) : (
        props.copyTextCaption ?? "copy text to clipboard"
      )}
    </div>
  );
}
